

















































import v8n from 'v8n';
import { Component, Vue, VModel } from 'vue-property-decorator';

import LegislationSelect from '@/components/common/LegislationSelect.vue';
import { Legislation, Recipe, OrganisationalEvent } from '@/api';
import { OrganisationalEventType } from '@/api/models/OrganisationalEvent';
import authModule from '@/store/Auth';

import ScenarioTester from '@/scenario-tester';
import ReportBuilder from '@/reports/ReportBuilder';

import Big from 'big.js';

@Component({ components: { LegislationSelect } })
export default class ActionLevelGridDialog extends Vue {
  @VModel({ type: Boolean }) dialog: boolean;

  loading = false;

  valid = false;

  referenceAmount = '100';

  legislation: Legislation | null = null;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('common.validation.generalRequired'),
  ];

  get activeOrg() {
    if (!authModule.activeOrganisation) {
      throw new Error(
        this.$t('common.alerts.missingActiveOrganisation') as string,
      );
    }
    return authModule.activeOrganisation.organisation;
  }

  async generate() {
    if (!this.legislation) {
      throw new Error('no legislation selected');
    }

    const scenario = new ScenarioTester(
      new Legislation(),
      this.activeOrg,
      new Recipe(),
      {
        useCalculatedOutcomes: false,
      },
    );
    new ReportBuilder(scenario)
      .actionLevelGrid(this.legislation, Big(this.referenceAmount))
      .open();

    const orgEvent = new OrganisationalEvent({
      organisation: this.activeOrg,
      eventType: OrganisationalEventType.ActionLevelGrid,
      details: {
        legislation_core_id: this.legislation.coreId,
        reference_amount: this.referenceAmount,
      },
    });
    await orgEvent.save({ with: 'organisation' });
  }
}
